import { useCallback, useMemo } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";

import { useApi } from "shared/services/api/useApi";
import { useParams } from "react-router-dom";

const useAccessGroupLanding = () => {
    const { getDataAsync } = useApi();

    const getAccessGroupLandingApiCall = useCallback(async () => {
        const response = await getDataAsync("pagesDirectory");

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    return useMemo(() => {
        const usePageDirectory = () =>
            useQuery("accessGroupsPages", getAccessGroupLandingApiCall);

        return {
            usePageDirectory,
        };
    }, [getAccessGroupLandingApiCall]);
};

export const useLandingDefaultPage = () => {
    const { getDataAsync, postData } = useApi();
    const queryClient = useQueryClient();
    const { groupId } = useParams();

    const getLandingDefaultPageApiCall = useCallback(
        async () => {
            const response = await getDataAsync("getDefaultPage", {
                urlParams: [{ name: "$groupId", value: groupId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;
        },
        [getDataAsync, groupId]
    );

    const saveLandingDefaultPage = useCallback(
        ({ pageId }) => {
            return postData("saveDefaultPage", {
                urlParams: [
                    { name: "$groupId", value: groupId },
                    { name: "$pageId", value: pageId },
                ],
            });
        },
        [postData, groupId]
    );

    const mutationOptions = useMemo(() => {
        return {
            onSuccess: () => {
                queryClient.invalidateQueries(["landingDefaultPage", groupId]);
            },
        };
    }, [queryClient, groupId]);

    const saveDefaultPage = useMutation(
        saveLandingDefaultPage,
        mutationOptions
    );

    return useMemo(() => {
        const useDefaultPage = () =>
            useQuery(["landingDefaultPage", groupId], () =>
                getLandingDefaultPageApiCall(groupId)
            );

        return {
            useDefaultPage,
            saveDefaultPage,
        };
    }, [getLandingDefaultPageApiCall, saveDefaultPage, groupId]);
};

export default useAccessGroupLanding;
